<template>
  <div>
    <el-dialog
      class="sendModal"
      :title="$t('stores::order::deliver_solutions')"
      :visible.sync="isSendModalShow"
      width="800px"
      bodyHeight="600px"
      :close-on-click-modal="false"
      @closed="closed"
    >
      <div v-loading="loading">
        <div class="step-wrap">
          <div class="step-item" v-for="(item, index) in steps" :key="index">
            <i class="el-icon-success" v-if="step >= index"></i>
            <span class="step-number" v-else>{{ index + 1 }}</span>
            <span class="step-title" :class="{ active: step >= index }">{{ $t(`stores::order::${item}`) }}</span>
            <div class="step-line" :class="{ active: step > index }" v-if="index != steps.length - 1"></div>
          </div>
        </div>
        <div v-show="step === 0">
          <div class="info-wrap">
            <span>{{ $t('stores::order::deliver_fee_plan') }}：</span>
            <span style="color: #ff4041">{{ $dataCheck(isSendModalData.shippingTitle) }}</span>
          </div>
          <div class="content-title">
            {{ $t('stores::order::delivery_info') }}
          </div>
          <z-table
            ref="sendTable"
            class="sendTable"
            :data="isSendModalData.orderItems"
            :columns="isSendModalColumns"
            :selection="true"
            :pagination="false"
            @selection-change="sendSelectChange"
          >
            <template #title="{ row }">
              <div class="goods-info">
                <el-image
                  :src="row.imageUrl"
                  :preview-src-list="[row.imageUrl]"
                  alt=""
                  class="order-item-img"
                ></el-image>
                <div>
                  <el-tooltip effect="dark" :content="row.title" placement="top">
                    <p class="order-item-title">
                      {{ row.title }}
                    </p>
                  </el-tooltip>
                  <p class="order-item-desc">
                    SPU：{{ $dataCheck(row.spuId) }} | {{ $dataCheck(row.variantOptionValue)
                    }}{{ filterVariant(row.variantCustomizedOption) }}
                  </p>
                  <p class="order-item-desc">SKU：{{ $dataCheck(row.skuId) }}</p>
                </div>
              </div>
            </template>
            <template #weight="{ row }">{{ row.totalWeight }}kg/{{ $t('stores::order::item') }}</template>
          </z-table>
          <div class="select-title">
            <div>{{ $t('stores::order::select_goods_total', { x: totalQuantity }) }} {{ totalWeight }}kg</div>
            <div class="total-goods">
              {{ $t('stores::order::fulfilment_goods', { goodsNum: isSendModalData.orderItems.length }) }}
            </div>
          </div>
        </div>
        <div v-if="step === 2">
          <div class="form-wrap">
            <el-form ref="sendModalForm" inline :rules="sendModalFormRules" :model="sendModalForm" label-width="auto">
              <el-form-item :label="`${$t('stores::order::fulfilment_type')}:`" prop="id">
                <el-select
                  style="width: 285px"
                  v-model="sendModalForm.id"
                  :placeholder="$t('system::common::input_holder')"
                  :popper-append-to-body="false"
                >
                  <el-option v-for="item in sendOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${$t('stores::order::deliver_time')}:`" prop="time">
                <el-date-picker
                  style="width: 285px"
                  v-model="sendModalForm.time"
                  type="datetime"
                  :placeholder="$t('stores::order::select_date')"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  @change="checkTime"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="`${$t('stores::order::fulfilment_number')}:`" prop="number">
                <el-input
                  style="width: 660px"
                  v-model="sendModalForm.number"
                  :placeholder="$t('stores::order::ship_input_fulfilment')"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="order-wrap">
            <div class="content-title">
              {{ $t('stores::order::order_info') }}
            </div>
            <div class="order-info-wrap">
              <div class="order-info">
                <div style="position: relative">
                  <el-image class="order-info-img" :src="sendDataList[0].imageUrl"></el-image>
                  <template v-if="sendDataList.length > 1">
                    <div class="border-line"></div>
                    <div class="border-line"></div>
                  </template>
                </div>
                <div>
                  <div>{{ $t('stores::order::order_number') }}：{{ orderDetail.orderNo }}</div>
                  <p class="tips">{{ $t('stores::order::total_weight') }}：{{ totalWeight }}kg</p>
                </div>
              </div>
              <div class="order-right">
                <div>{{ $t('stores::order::all_goods_number', { number: sendDataList.length }) }}</div>
                <el-button type="text" size="mini" @click="unfold = !unfold">
                  {{ unfold ? $t('system::common::btn::pick_up') : $t('system::common::btn::unfold') }}
                </el-button>
              </div>
            </div>
            <div v-show="unfold">
              <z-table
                class="selectTable"
                :data="sendDataList"
                :columns="isSendModalColumns"
                :selection="false"
                :pagination="false"
                :show-header="false"
              >
                <template #title="{ row }">
                  <div class="goods-info">
                    <el-image
                      :src="row.imageUrl"
                      :preview-src-list="[row.imageUrl]"
                      alt=""
                      class="order-item-img"
                    ></el-image>
                    <div>
                      <el-tooltip effect="dark" :content="row.title" placement="top">
                        <p class="order-item-title">
                          {{ row.title }}
                        </p>
                      </el-tooltip>
                      <p class="order-item-desc">
                        SPU：{{ $dataCheck(row.spuId) }} | {{ $dataCheck(row.variantOptionValue)
                        }}{{ filterVariant(row.variantCustomizedOption) }}
                      </p>
                      <p class="order-item-desc">SKU：{{ $dataCheck(row.skuId) }}</p>
                    </div>
                  </div>
                </template>
                <template #weight="{ row }">{{ row.totalWeight }}kg/{{ $t('stores::order::item') }}</template>
              </z-table>
            </div>
          </div>
        </div>
        <div v-show="step !== 1">
          <div class="content-title">
            {{ $t('stores::order::customer_info') }}
          </div>
          <div class="customer-info">
            <div class="customer-info-item">
              {{ $t('stores::order::receiver') }}: {{ isSendModalData.firstName }} {{ isSendModalData.lastName }}
            </div>
            <div class="customer-info-item">{{ $t('stores::order::zip') }}:{{ isSendModalData.zip }}</div>
            <div class="customer-info-item">{{ $t('stores::order::email') }}:{{ isSendModalData.email }}</div>
            <div class="customer-info-item">{{ $t('stores::order::phone') }}:{{ isSendModalData.phone }}</div>
            <div class="customer-info-item" style="max-width: 67%">
              {{ $t('stores::order::address') }}:{{ isSendModalData.country }} {{ isSendModalData.province }}
              {{ isSendModalData.city }} {{ isSendModalData.address1 }} {{ isSendModalData.address2 }}
            </div>
          </div>
        </div>
        <div v-show="step === 1">
          <template v-if="totalWeight > 0">
            <div v-if="bindLogistics" style="margin-top: 10px">
              <div v-for="item in deliverList" :key="item.id">
                <template v-if="item.status !== 0">
                  <div class="content-title">
                    {{ $t(item.key) }}
                  </div>
                  <z-table
                    v-loading="deliveryLoading"
                    :data="item.list"
                    :columns="deliveryColumns"
                    :pagination="false"
                    :customEmpty="true"
                    :empty-text="$t('stores::order::ship_inside')"
                    :max-height="150"
                    border
                  >
                    <template #cname="{ row }">
                      {{ $dataCheck(row.cname) }}
                      <el-tag type="danger" v-if="Math.min(...item.list.map(i => i.totalFee)) === row.totalFee">
                        {{ $t('stores::order::recommend') }}
                      </el-tag>
                    </template>
                    <template #shippingFee="{ row }">
                      {{ $dataCheck(row.shippingFee) }}
                    </template>
                    <template #otherFee="{ row }">
                      {{ $dataCheck(row.otherFee) }}
                    </template>
                    <template #totalFee="{ row }">
                      {{ $dataCheck(row.totalFee) }}
                    </template>
                    <template #deliveryDays="{ row }">
                      {{ $dataCheck(row.deliveryDays) }}
                    </template>
                    <template #selection="{ row }">
                      <el-checkbox
                        :disabled="planId ? row.id != planId : false"
                        @change="bool => selectPlan(row.id, bool, item.id)"
                      ></el-checkbox>
                    </template>
                    <div slot="empty">
                      <span v-if="item.id === 28">{{ $t('stores::order::ship_inside') }}</span>
                      <span v-else-if="item.id === 52">
                        {{ $t('stores::order::ship_auth') }}
                        <el-button type="text" @click="toD4xAuth(item.url)">
                          {{ $t('stores::order::重新授权') }}
                        </el-button>
                      </span>
                    </div>
                  </z-table>
                </template>
              </div>
            </div>
            <div style="text-align: center; padding: 20px" v-if="!bindLogistics">
              <p>{{ $t('stores::order::not_fulfilment') }}</p>
              <el-button type="primary" style="margin-top: 10px；margin-right: 10px;" @click="dialogVisible = true">
                {{ $t('stores::order::bind_fulfilment') }}
              </el-button>
              <el-button type="primary" style="margin-top: 10px" @click="sendGoods">
                {{ $t('stores::order::to_deliver') }}
              </el-button>
            </div>
          </template>
          <div style="text-align: center; padding: 20px" v-if="totalWeight === 0">
            <p>{{ $t('stores::order::weigth_zero') }}</p>
            <!-- <el-button type="primary" style="margin-top: 10px" @click="sendGoods">
              {{ $t('stores::order::to_deliver') }}
            </el-button> -->
          </div>
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button @click="backStep">
          {{ step ? $t('stores::order::prev_step') : $t('system::common::btn::cancel') }}
        </el-button>
        <el-button type="primary" @click="submitConfirmSend" :loading="sendLoading">
          {{ step === 2 ? $t('stores::order::confirm_delivery') : $t('stores::order::next_step') }}
        </el-button>
      </div>
    </el-dialog>
    <logisticsDialog v-model="dialogVisible" @closeDialog="closeDialog"></logisticsDialog>
  </div>
</template>

<script>
import { getOrderSendMessage, getSendDeliver, putSend, getYuntuFee, getD4pxFee, getLogisticsFee } from '@/server/order'
import { sendModalFormRules, isSendModalColumns, deliveryColumns } from './config'
import logisticsDialog from '@/views/store/logisticsSetting/handleDialog'
import { getLogisticsList } from '@/server/logistics'
import { filterVariant } from '@/utils/utils'
export default {
  name: 'ShipDialog',
  components: { logisticsDialog },
  props: {
    value: {},
    orderDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      step: 0,
      dialogVisible: false, // 绑定物流商弹窗判断
      isSendModalShow: false,
      sendOptions: [],
      sendDataList: [],
      deliverList: [
        {
          id: 28, // 云途物流id
          key: 'stores::order::yuntu',
          list: [],
        },
        {
          id: 52, // 递四方id
          key: 'stores::order::d4px',
          list: [],
        },
      ],
      yuntuList: [], // 物流商数据
      d4pxList: [], // 物流商数据
      totalWeight: 0, // 总重量
      totalQuantity: 0, // 总件数
      bindLogistics: true,
      deliveryLoading: false,
      sendLoading: false,
      sendModalForm: {
        id: '',
        number: '',
        time: '',
      },
      isSendModalData: {
        orderItems: [],
      },
      isSendModalColumns,
      sendModalFormRules,
      deliveryColumns,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < Date.parse(new Date(this.orderDetail.createTime)) - 8.64e7
        },
      },
      steps: ['选择商品', '选择运输方案', '确定发货'],
      unfold: false,
      planId: '',
    }
  },
  created() {
    this.getFulfillment()
  },
  methods: {
    filterVariant,
    checkTime(time) {
      if (!time || Date.parse(new Date(time)) > Date.parse(new Date(this.orderDetail.createTime))) return
      const tempTime =
        (this.orderDetail.createTime && time.split(' ')[0] + ' ' + this.orderDetail.createTime.split(' ')[1]) || time
      this.sendModalForm.time = tempTime
    },
    async getSendData() {
      this.loading = true
      const { data } = await getOrderSendMessage({ orderNo: this.orderDetail.orderNo })
      this.loading = false
      if (data.code === this.$code) {
        this.isSendModalData = data.data
      }
    },
    async confirmSend() {
      const trackCodeItem = this.sendOptions.find(i => i.id === this.sendModalForm.id)
      var obj = {
        order_item_ids: this.sendDataList.map(item => {
          return String(item.id)
        }),
        shippingCompanyId: this.sendModalForm.id,
        order_no: this.isSendModalData.orderNo,
        tracking_number: this.sendModalForm.number,
        tracking_company: (trackCodeItem && trackCodeItem.trackCode) || '',
        deliver_time: this.sendModalForm.time,
      }
      this.sendLoading = true
      const { data } = await putSend(obj)
      this.sendLoading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('stores::order::deliver_success'))
        this.isSendModalShow = false
        for (let key in this.sendModalForm) {
          this.sendModalForm[key] = ''
        }
        this.$emit('getDetail', this.orderDetail.orderNo)
      }
    },
    submitConfirmSend() {
      if (this.sendDataList.length === 0) return this.$message.warning(this.$t('stores::order::deliver_message'))
      if (this.step === 2) {
        this.$refs.sendModalForm.validate(valid => {
          if (valid) {
            this.confirmSend()
          } else {
            return false
          }
        })
      } else {
        this.step++
      }
    },
    sendSelectChange(value) {
      this.sendDataList = value
      let total = 0
      let totalQuantity = 0
      value.forEach(item => {
        total += item.totalWeight * item.quantity
        totalQuantity += item.quantity
      })
      this.totalWeight = Number(total.toFixed(4))
      this.totalQuantity = totalQuantity
    },
    async getFulfillment() {
      const { data } = await getSendDeliver({ dictCode: 'shipping_company' })
      if (data.code === this.$code) {
        this.sendOptions = data.data
      }
    },
    async getDeliverFeeList() {
      this.deliveryLoading = true
      const params = {
        countryCode: this.isSendModalData.countryCode,
        weight: this.totalWeight,
      }
      let data = await getLogisticsFee(params)
      console.log(data.data, 'wuliu')
      if (data.data.code === this.$code) {
        this.deliverList[0].list = data.data.data[0].list.map((item, index) => ({
          ...item,
          id: `y-${index}`,
        }))
        this.deliverList[0].status = data.data.data[0].status
        this.deliverList[1].list = data.data.data[1].list.map((item, index) => ({
          ...item,
          id: `d-${index}`,
        }))
        this.deliverList[1].status = data.data.data[1].status
        this.deliverList[1].url = data.data.data[1].url
        this.bindLogistics = !!(this.deliverList[0].status || this.deliverList[1].status)
      }
      this.deliveryLoading = false
      // const [yuntu, d4px] = await Promise.all([getYuntuFee(params), getD4pxFee(params)])
      // this.deliveryLoading = false
      // if (yuntu.data.code === this.$code) {
      //   this.bindLogistics = true
      //   this.deliverList[0].list = (yuntu.data.data || []).map((item, index) => ({
      //     ...item,
      //     id: `y-${index}`
      //   }))
      // } else if (yuntu.data.code === 12003) {
      //   this.bindLogistics = false
      // }
      // if (d4px.data.code === this.$code) {
      //   this.deliverList[1].list = (d4px.data.data || []).map((item, index) => ({
      //     ...item,
      //     id: `d-${index}`
      //   }))
      // }
    },
    toD4xAuth(url) {
      window.open(url, '_blank')
    },
    async closeDialog(refresh) {
      this.dialogVisible = false
      if (refresh) {
        await this.getDeliverFeeList()
      }
    },
    sendGoods() {
      this.step = 2
    },
    backStep() {
      if (this.step > 0) {
        this.step--
      } else {
        this.isSendModalShow = false
      }
    },
    selectPlan(id, bool, delivery) {
      if (bool) {
        this.planId = id
        this.sendModalForm.id = delivery
      } else {
        this.planId = ''
        this.sendModalForm.id = ''
      }
    },
    closed() {
      // 初始化
      const initData = { ...this.$options.data() }
      delete initData.sendOptions
      for (const key in initData) {
        this[key] = initData[key]
      }
    },
  },
  watch: {
    isSendModalShow(val) {
      this.$refs.sendModalForm && this.$refs.sendModalForm.resetFields()
      this.$emit('input', val)
      if (val && this.orderDetail.orderNo) {
        this.getSendData()
      }
    },
    value(value) {
      this.isSendModalShow = value
    },
    sendDataList(val) {
      console.log(val)
      if (val && val.length > 0) {
        this.getDeliverFeeList()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-collapse-item__header,
/deep/.el-collapse-item__content {
  color: #5d6494;
}
/deep/.el-collapse-item__header {
  background: #f0f2f5;
  padding: 0 10px;
}
/deep/.sendTable .el-table {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
/deep/.selectTable .el-table {
  tr {
    background: #f4f4f4;
  }
}
.sendModal {
  .step-wrap {
    display: flex;
    justify-content: space-between;
    .step-item {
      display: flex;
      align-items: center;
      flex: 1;
      .step-number {
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        border-radius: 50%;
        font-size: 12px;
        color: #fff;
        background: #999999;
      }
      .el-icon-success {
        font-size: 20px;
        color: #0560fd;
      }
      .step-title {
        display: inline-block;
        line-height: 20px;
        margin-left: 4px;
        color: #999999;
        &.active {
          color: #0560fd;
        }
      }
      .step-line {
        flex: 1;
        height: 1px;
        background: #e5e5e5;
        margin: 0 5px;
        &.active {
          background: #0560fd;
        }
      }
      &:last-child {
        flex: 0 0 80px;
      }
    }
  }
  .content-title {
    font-weight: bold;
    color: #010517;
    margin: 24px 0 16px;
  }
  .goods-info {
    display: flex;
    align-items: center;
  }
  .select-title {
    height: 46px;
    line-height: 46px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 0 16px;
    border: 1px solid #dddddd;
    border-top: 0px;
    display: flex;
    justify-content: space-between;
    .total-goods {
      font-size: 14px;
      color: #999999;
    }
  }
  .customer-info {
    display: flex;
    flex-wrap: wrap;
    &-item {
      margin-bottom: 16px;
      min-width: 33%;
      color: #666666;
    }
  }
  .info-wrap {
    height: 40px;
    background: #f9fbff;
    border: 1px solid #bad1ff;
    display: flex;
    align-items: center;
    padding: 0 16px;
    margin-top: 24px;
  }
  .order-item-img {
    width: 64px;
    height: 64px;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    object-fit: cover;
    margin-right: 24px;
  }
  .order-item-title {
    display: block;
    font-size: 14px;
    font-weight: bold;
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis; /* 加省略号 */
    white-space: nowrap; /* 强制不换行 */
  }
  .order-item-desc {
    font-size: 12px;
    color: #666666;
  }
  .form-wrap {
    padding: 36px 20px 0;
    border-bottom: 1px solid #dddddd;
    margin: 0 -20px;
  }
  .order-info-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .order-info {
      display: flex;
      .order-info-img {
        width: 43px;
        height: 43px;
        border-radius: 5px;
        margin-right: 24px;
        border: 1px solid #d9d9d9;
        z-index: 10;
      }
      .tips {
        color: #999999;
        font-size: 12px;
        margin-top: 5px;
      }
      .border-line {
        position: absolute;
        top: 0;
        left: 4px;
        width: 43px;
        height: 43px;
        background: #f7f7f7;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        &:nth-child(2) {
          top: 3px;
          left: 13px;
          width: 37px;
          height: 37px;
        }
      }
    }
    .order-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
}
.el-tag {
  height: 22px;
  line-height: 20px;
}
</style>
